import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ElevenLabsVoiceService {
    constructor(private http: HttpClient) {}

    async synthesize(text: string): Promise<Blob> {
        // The application's POST interceptor encrypts `body` before it leaves
        // the browser. Keep the voice request on the same protected path.
        return firstValueFrom(this.http.post('api/voice/speak', { body: { text } }, {
            headers: new HttpHeaders({ 'ngsw-bypass': '' }),
            responseType: 'blob',
        }));
    }

    async createScribeToken(): Promise<string> {
        const response = await firstValueFrom(this.http.post<{ token: string }>('api/voice/scribe-token', { body: {} }, {
            headers: new HttpHeaders({ 'ngsw-bypass': '' }),
        }));
        return String(response?.token || '');
    }
}
